var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4673 10.5333L14.4673 13.5333C14.734 13.8 14.734 14.2 14.4673 14.4667C14.334 14.6 14.134 14.6667 14.0007 14.6667C13.8673 14.6667 13.6673 14.6 13.534 14.4667L10.534 11.4667C9.53399 12.2 8.33398 12.6667 7.00065 12.6667C3.86732 12.6667 1.33398 10.1333 1.33398 7C1.33398 3.86666 3.86732 1.33333 7.00065 1.33333C10.134 1.33333 12.6673 3.86666 12.6673 7C12.6673 8.33333 12.2007 9.6 11.4673 10.5333ZM7.00065 2.66666C4.60065 2.66666 2.66732 4.59999 2.66732 6.99999C2.66732 9.39999 4.60065 11.3333 7.00065 11.3333C8.20065 11.3333 9.26732 10.8667 10.0673 10.0667C10.8673 9.26666 11.334 8.19999 11.334 6.99999C11.334 4.59999 9.40065 2.66666 7.00065 2.66666Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_779_17056",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4673 10.5333L14.4673 13.5333C14.734 13.8 14.734 14.2 14.4673 14.4667C14.334 14.6 14.134 14.6667 14.0007 14.6667C13.8673 14.6667 13.6673 14.6 13.534 14.4667L10.534 11.4667C9.53399 12.2 8.33398 12.6667 7.00065 12.6667C3.86732 12.6667 1.33398 10.1333 1.33398 7C1.33398 3.86666 3.86732 1.33333 7.00065 1.33333C10.134 1.33333 12.6673 3.86666 12.6673 7C12.6673 8.33333 12.2007 9.6 11.4673 10.5333ZM7.00065 2.66666C4.60065 2.66666 2.66732 4.59999 2.66732 6.99999C2.66732 9.39999 4.60065 11.3333 7.00065 11.3333C8.20065 11.3333 9.26732 10.8667 10.0673 10.0667C10.8673 9.26666 11.334 8.19999 11.334 6.99999C11.334 4.59999 9.40065 2.66666 7.00065 2.66666Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_779_17056)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#5E5873"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.f55a81d5a26307b83e3ab5556b2652cd.svg";
export { ForwardRef as ReactComponent };